export interface VideoItem {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  duration: string;
  quality: string;
  views: string;
  rating: number;
  year: string;
  description: string;
  tags: string[];
  releaseDate: string;
  director: string;
  cast: string[];
  episodeCount: string;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '春风十里不如你',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20romance%20drama%20movie%20poster%20with%20young%20couple%20in%20spring%20scenery%2C%20soft%20warm%20lighting%2C%20cinematic%20composition%2C%20emotional%20atmosphere%2C%20film%20grain%20texture%2C%20elegant%20Chinese%20typography%20style&width=720&height=960&seq=video-cover-001&orientation=portrait',
    category: '国产剧',
    duration: '45分钟',
    quality: '1080P',
    views: '328.5万',
    rating: 9.2,
    year: '2024',
    description: '一部讲述都市男女情感纠葛的精品剧集，画面唯美，剧情扣人心弦，带你感受最真实的情感故事。',
    tags: ['爱情', '都市', '剧情'],
    releaseDate: '2024-03-15',
    director: '张艺明',
    cast: ['刘诗雯', '王俊凯', '赵丽颖'],
    episodeCount: '36集全'
  },
  {
    id: 'v002',
    title: '暗夜追踪者',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20detective%20in%20dark%20city%20street%2C%20neon%20lights%20reflection%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20suspenseful%20mood&width=720&height=960&seq=video-cover-002&orientation=portrait',
    category: '国产剧',
    duration: '42分钟',
    quality: '4K',
    views: '256.8万',
    rating: 8.9,
    year: '2024',
    description: '悬疑犯罪题材力作，紧凑的剧情让你一集接一集停不下来，反转不断烧脑十足。',
    tags: ['悬疑', '犯罪', '刑侦'],
    releaseDate: '2024-05-20',
    director: '李安民',
    cast: ['陈道明', '周迅', '黄渤'],
    episodeCount: '24集全'
  },
  {
    id: 'v003',
    title: '古剑传说之仙缘',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20martial%20arts%20drama%20poster%20with%20ancient%20warrior%20in%20flowing%20robes%2C%20misty%20mountains%2C%20magical%20sword%2C%20ethereal%20golden%20light%2C%20traditional%20Chinese%20painting%20aesthetic&width=720&height=960&seq=video-cover-003&orientation=portrait',
    category: '古装剧',
    duration: '50分钟',
    quality: '1080P',
    views: '512.3万',
    rating: 9.5,
    year: '2024',
    description: '仙侠巨制，特效震撼，剧情宏大，带你进入一个充满奇幻色彩的仙侠世界。',
    tags: ['仙侠', '古装', '奇幻'],
    releaseDate: '2024-01-08',
    director: '陈凯歌',
    cast: ['杨洋', '迪丽热巴', '吴磊'],
    episodeCount: '48集全'
  },
  {
    id: 'v004',
    title: '职场风云录',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20office%20drama%20poster%20with%20professional%20people%20in%20modern%20skyscraper%20office%2C%20city%20skyline%20background%2C%20corporate%20atmosphere%2C%20clean%20professional%20photography&width=720&height=960&seq=video-cover-004&orientation=portrait',
    category: '国产剧',
    duration: '40分钟',
    quality: '1080P',
    views: '189.6万',
    rating: 8.7,
    year: '2024',
    description: '揭露职场真相的写实剧集，真实还原当代白领的奋斗与成长，笑中带泪的职场故事。',
    tags: ['职场', '都市', '励志'],
    releaseDate: '2024-06-10',
    director: '徐峥',
    cast: ['雷佳音', '袁泉', '张译'],
    episodeCount: '30集全'
  },
  {
    id: 'v005',
    title: '极速方程式',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20action%20racing%20movie%20poster%20with%20fast%20sports%20car%20on%20racetrack%2C%20motion%20blur%2C%20dramatic%20lighting%2C%20adrenaline%20filled%20atmosphere%2C%20cinematic%20action%20style&width=720&height=960&seq=video-cover-005&orientation=portrait',
    category: '电影',
    duration: '118分钟',
    quality: '4K',
    views: '445.2万',
    rating: 9.1,
    year: '2024',
    description: '热血赛车题材电影，速度与激情的完美融合，带你感受极限竞速的震撼体验。',
    tags: ['动作', '赛车', '热血'],
    releaseDate: '2024-04-28',
    director: '林超贤',
    cast: ['彭于晏', '张涵予', '刘昊然'],
    episodeCount: '电影'
  },
  {
    id: 'v006',
    title: '美食侦探社',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20and%20cooking%20drama%20poster%20with%20delicious%20Chinese%20cuisine%20dishes%2C%20warm%20restaurant%20interior%2C%20steaming%20hot%20food%2C%20cozy%20atmosphere%2C%20appetizing%20food%20photography&width=720&height=960&seq=video-cover-006&orientation=portrait',
    category: '综艺',
    duration: '60分钟',
    quality: '1080P',
    views: '278.9万',
    rating: 9.3,
    year: '2024',
    description: '一档美食探案综艺，明星嘉宾走遍全国各地寻找最地道的美食，边吃边破案，妙趣横生。',
    tags: ['美食', '综艺', '探案'],
    releaseDate: '2024-07-05',
    director: '何炅',
    cast: ['黄磊', '张亮', '谢霆锋', '杨紫'],
    episodeCount: '12期'
  },
  {
    id: 'v007',
    title: '山河令之风云再起',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20drama%20poster%20with%20two%20warriors%20in%20traditional%20armor%2C%20epic%20battlefield%20background%2C%20dramatic%20sky%2C%20heroic%20atmosphere%2C%20classic%20wuxia%20style&width=720&height=960&seq=video-cover-007&orientation=portrait',
    category: '古装剧',
    duration: '48分钟',
    quality: '4K',
    views: '623.7万',
    rating: 9.6,
    year: '2024',
    description: '年度最受期待古装武侠大作，双男主江湖恩怨，精彩打戏与深情演绎完美结合。',
    tags: ['武侠', '古装', '双男主'],
    releaseDate: '2024-02-14',
    director: '郭敬明',
    cast: ['肖战', '王一博', '李沁'],
    episodeCount: '42集全'
  },
  {
    id: 'v008',
    title: '我家那闺女第三季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20show%20poster%20with%20happy%20family%20in%20modern%20home%2C%20bright%20cheerful%20atmosphere%2C%20reality%20TV%20style%2C%20warm%20lighting%2C%20casual%20family%20portrait&width=720&height=960&seq=video-cover-008&orientation=portrait',
    category: '综艺',
    duration: '75分钟',
    quality: '1080P',
    views: '198.4万',
    rating: 8.8,
    year: '2024',
    description: '温情家庭观察类综艺，明星父女日常真实记录，笑点与泪点齐飞的家庭故事。',
    tags: ['家庭', '观察', '综艺'],
    releaseDate: '2024-08-12',
    director: '吴彤',
    cast: ['贾玲', '沈腾', '关晓彤'],
    episodeCount: '12期'
  },
  {
    id: 'v009',
    title: '深海迷踪',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20disaster%20movie%20poster%20with%20deep%20ocean%20scene%2C%20mysterious%20underwater%20creature%2C%20dark%20blue%20tones%2C%20submarine%2C%20thrilling%20atmosphere%2C%20cinematic%20epic%20scale&width=720&height=960&seq=video-cover-009&orientation=portrait',
    category: '电影',
    duration: '135分钟',
    quality: '4K',
    views: '567.1万',
    rating: 9.0,
    year: '2024',
    description: '国产科幻灾难大片，深海探险遭遇未知生物，视觉特效震撼人心，剧情悬念十足。',
    tags: ['科幻', '灾难', '冒险'],
    releaseDate: '2024-09-01',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
    episodeCount: '电影'
  },
  {
    id: 'v010',
    title: '青春纪念册',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20school%20drama%20poster%20with%20students%20in%20school%20uniform%2C%20sunny%20campus%2C%20cherry%20blossoms%2C%20nostalgic%20warm%20atmosphere%2C%20coming%20of%20age%20story&width=720&height=960&seq=video-cover-010&orientation=portrait',
    category: '国产剧',
    duration: '38分钟',
    quality: '1080P',
    views: '156.2万',
    rating: 8.6,
    year: '2024',
    description: '青春校园剧清新之作，带你回到那个充满梦想与热血的少年时代。',
    tags: ['青春', '校园', '成长'],
    releaseDate: '2024-07-20',
    director: '赵薇',
    cast: ['易烊千玺', '周冬雨', '刘浩存'],
    episodeCount: '24集全'
  },
  {
    id: 'v011',
    title: '大秦帝国之纵横天下',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20drama%20poster%20with%20ancient%20Chinese%20emperor%20and%20palace%2C%20grand%20scale%2C%20golden%20imperial%20colors%2C%20dramatic%20composition%2C%20historical%20authenticity&width=720&height=960&seq=video-cover-011&orientation=portrait',
    category: '历史剧',
    duration: '52分钟',
    quality: '4K',
    views: '789.3万',
    rating: 9.7,
    year: '2024',
    description: '史诗级历史巨制，还原大秦帝国波澜壮阔的历史画卷，权谋与战争的交织震撼人心。',
    tags: ['历史', '权谋', '战争'],
    releaseDate: '2024-01-25',
    director: '张黎',
    cast: ['陈宝国', '张丰毅', '倪大红'],
    episodeCount: '56集全'
  },
  {
    id: 'v012',
    title: '月球基地',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20space%20movie%20poster%20with%20astronaut%20on%20moon%20surface%2C%20Earth%20in%20background%2C%20futuristic%20space%20station%2C%20epic%20cosmic%20scale%2C%20cinematic%20sci-fi%20aesthetic&width=720&height=960&seq=video-cover-012&orientation=portrait',
    category: '电影',
    duration: '142分钟',
    quality: '4K',
    views: '892.1万',
    rating: 9.4,
    year: '2024',
    description: '中国科幻电影新里程碑，讲述人类在月球建立永久基地的壮丽史诗。',
    tags: ['科幻', '太空', '冒险'],
    releaseDate: '2024-10-01',
    director: '吴京',
    cast: ['吴京', '赵今麦', '沙溢'],
    episodeCount: '电影'
  }
];

export const getVideosByCategory = (category: string): VideoItem[] => {
  return videos.filter(v => v.category === category);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find(v => v.id === id);
};